export default __webpack_public_path__ + "assets/f6f89e47c2dd39c85535b7c1db9f6932.jpeg";